import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const NavWrapper: React.FC<Props> = ({ children }) => {
    const theme = useTheme();
    const { burgerHeightMain, heightMain } = theme.sizes.menu;

    const style = css`
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        width: ${theme.breakpoints.sizes['xxl']}px;
        height: ${heightMain}px;
        background-color: ${theme.colours.white};

        ${theme.breakpoints.up('5xl')} {
            width: ${theme.breakpoints.sizes['5xl']}px;
        }

        ${theme.breakpoints.between('3xl', '4xl')} {
            width: ${theme.breakpoints.sizes['3xl']}px;
        }

        ${theme.breakpoints.down('xl')} {
            width: ${theme.breakpoints.sizes['xl']}px;
        }
        
        ${theme.breakpoints.down('lg')} {
            height: ${burgerHeightMain}px;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default NavWrapper;